export class WFEOwnerResultDto {
    ownerId: number;
    customerId: string;
    isCurrentOwner: boolean;
    ownerName: string;
    propertyAddress: string;
}
